import PdfConverter from '@/components/PdfConverter';

const PdfConverterPage = () => {
  return (
    <div className="py-8">
      <div className="container mx-auto px-4">
        <h1 className="text-3xl font-bold mb-8 text-center">PDF Converter</h1>
        <PdfConverter />
      </div>
    </div>
  );
};

export default PdfConverterPage;
